import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the organizationPage state domain
 */

const selectOrganizationPageDomain = (state) =>
  state.get("organizationPage", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by OrganizationPage
 */

export const makeSelectCreateModal = () =>
  createSelector(selectOrganizationPageDomain, (state) =>
    state.get("createModal")
  )

export const makeSelectMeditions = () =>
  createSelector(selectOrganizationPageDomain, (state) =>
    state.get("meditions")
  )
export const makeSelectMeditionsOfficialized = () =>
  createSelector(selectOrganizationPageDomain, (state) =>
    state.get("meditionsOfficialized")
  )

export const makeSelectVismaPeopleStatus = () =>
  createSelector(selectOrganizationPageDomain, (state) =>
    state.get("vismaPeopleStatus")
  )

export const makeSelectIsLoadingVismaPeopleStatus = () =>
  createSelector(selectOrganizationPageDomain, (state) =>
    state.get("isLoadingVismaPeopleStatus")
)

const makeSelectOrganizationPage = () =>
  createSelector(selectOrganizationPageDomain, (substate) => substate.toJS())

export default makeSelectOrganizationPage
export { selectOrganizationPageDomain }
